export default "__VITE_ASSET__Dfi8y$GG__"